import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Body1, H2 } from 'components/Typography';
import m from 'messages';

function groupRoles(jobRolesArray) {

    const groupedJobs = new Map();

    (jobRolesArray || []).forEach(job => {

        let jobScope = groupedJobs.get(job.scope);
        if (!jobScope) {
            jobScope = [];
            groupedJobs.set(job.scope, jobScope);
        }

        jobScope.push(job);
    });

    return groupedJobs;
}

class JobRoles extends React.Component {

    emptyList() {
        return (
            <Body1 paragraph>
                {m.cards.noJobRoles}
            </Body1>
        );
    }

    jobRolesList(groupedJobs) {
        return (
            <React.Fragment>
                {Array.from(groupedJobs.keys()).map((key, index) =>
                    <div key={index}>
                        <Typography variant="h6" paragraph={true}>{key}</Typography>
                        {groupedJobs.get(key).map((job, index) =>
                            <div key={index}>
                                <Typography variant="body1" paragraph={true}>
                                    {job.displayName()}
                                </Typography>
                                <Divider />
                            </div>
                        )}
                    </div>
                )}
            </React.Fragment>
        )
    }
    render() {
        const { card } = this.props;

        const groupedJobs = groupRoles(card.jobRolesArray);
        const hasJobRoles = groupedJobs && groupedJobs.size > 0;

        return (
            <div>
                <H2 paragraph>
                    {m.cards.jobRolesTitle}
                </H2>
                {hasJobRoles ? this.jobRolesList(groupedJobs) : this.emptyList()}
            </div>
        );
    }
}

JobRoles.propTypes = {
    card: PropTypes.object
};

export default JobRoles;